import { render } from "./TabsPage.vue?vue&type=template&id=462b5322&scoped=true"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=462b5322&scoped=true&lang=scss"

import exportComponent from "/home/aix/www/preprod/community_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462b5322"]])

export default __exports__